// extracted by mini-css-extract-plugin
module.exports = {"container":"conversation-items-list-types-container__yckHF"};